













import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import makeSelectOptions from "@common/util/makeSelectOptions";
import BlurredTenant from "@/components/BlurredTenant.vue";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";

const adjustmentTypes = {
  UNDERCHARGE: "Undercharge",
  OVERCHARGE: "Overcharge",
  MEMBERSHIP_FIX: "Membership Fix",
};

export default Vue.extend({
  components: { BlurredTenant },
  computed: {
    featureDisabled(): boolean {
      return !this.$store.state.featureConfig?.retroactiveCharge?.enabled;
    },
  },
  data() {
    const vueInstance = this;
    return {
      tableContainer: new DataContainer(),
      showBlur:
        userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) &&
        !!userManager.getUserInfo().tenant?.setting?.expDate &&
        userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      self: this,
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "Retroactive Charges",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Organization",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("tenants", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              userId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "User",
                  required: true,
                  "item-value": "_id",
                  "item-text": "email",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAllUser", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "email",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                            extraParams: {
                              searchCrossTenant: !!search && true,
                            },
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              transactionId: {
                type: "text",
                attrs: {
                  label: "Transaction ID",
                },
                rules: {
                  equal_to: {},
                },
              },
              adjustmentType: {
                type: "selectMultiple",
                attrs: {
                  label: "Adjustment Type",
                  items: makeSelectOptions(adjustmentTypes),
                },
                rules: {
                  in: {},
                },
              },
            },
          },
          displayFields: {
            createdTime: {
              text: "Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            transactionId: {
              text: "Transaction ID",
              options: {
                subProp: "session.details._id",
                label: true,
              },
            },
            user: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
              text: "User",
              options: {
                subProp: "user.email",
                label: true,
                sortBy: "userId",
              },
            },
            tenant: userManager.checkRole(["systemAdmin", "admin"]) && {
              text: "Organization",
              options: {
                subProp: "tenant.name",
                label: true,
                sortBy: "tenantId",
              },
            },
            adjustmentType: {
              text: "Adjustment Type",
              sortable: true,
              options: {
                transform: (value) => adjustmentTypes[value] || value,
                label: true,
              },
            },
            pointDelta: {
              text: "Point Delta",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            reason: {
              text: "Reason",
            },
            notes: {
              text: "Notes",
              hidden: true,
            },
            appliedBy: {
              text: "Applied By",
              hidden: true,
            },
            notificationSent: {
              text: "Notification Sent",
              hidden: true,
              options: {
                transform: (value) => (value ? "Yes" : "No"),
              },
            },
          },
          topActionButtons: {
            add: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                text: "Add",
                icon: "mdi-plus",
              },
              target: {
                dialog: {
                  attrs: {
                    width: "600px",
                  },
                  content: {
                    toolbar: {
                      title: "Create Retroactive Charge",
                    },
                    content: {
                      type: "XForm",
                      attrs: {
                        xOptions: {
                          content: {
                            sections: {
                              default: {
                                fields: {
                                  sessionId: {
                                    type: "XAutocomplete",
                                    attrs: {
                                      label: "Transaction ID",
                                      required: true,
                                      "item-value": "_id",
                                      "item-text": (item) =>
                                        [
                                          item.details?._id,
                                          item.userSnapshot?.email,
                                          item.startTime
                                            ? new Date(item.startTime).toLocaleString("vi-VN")
                                            : "",
                                        ]
                                          .filter(Boolean)
                                          .join(" — "),
                                      xOptions: {
                                        content: {
                                          async itemsSuggestor(search, value, limit) {
                                            const filters: any[] = [];
                                            if (value) {
                                              filters.push({ key: "details._id", operator: "equal_to", value: Number(value) });
                                            } else if (search) {
                                              if (/^\d+$/.test(search)) {
                                                filters.push({ key: "details._id", operator: "equal_to", value: Number(search) });
                                              } else {
                                                filters.push({ key: "userSnapshot.email", operator: "match", value: search });
                                              }
                                            }
                                            const { items } = await coreApiClient.call(
                                              "chargingSessions",
                                              "findAll",
                                              {
                                                payload: JSON.stringify({
                                                  limit,
                                                  orderBy: "startTime",
                                                  orderType: "desc",
                                                  filters,
                                                }),
                                              }
                                            );
                                            return items;
                                          },
                                        },
                                      },
                                    },
                                  },
                                  adjustmentType: {
                                    type: "select",
                                    attrs: {
                                      label: "Adjustment Type",
                                      required: true,
                                      items: makeSelectOptions(adjustmentTypes),
                                    },
                                  },
                                  pointDelta: {
                                    type: "number",
                                    attrs: {
                                      label: "Point Delta",
                                      required: true,
                                      hint: "Positive = refund to user, Negative = additional charge",
                                      persistentHint: true,
                                    },
                                  },
                                  reason: {
                                    type: "text",
                                    attrs: {
                                      label: "Reason",
                                      required: true,
                                    },
                                  },
                                  notes: {
                                    type: "text",
                                    attrs: {
                                      label: "Notes",
                                      rows: 3,
                                      hint: "Internal notes, not visible to users",
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    buttons: {
                      save: {
                        content: {
                          text: "Create",
                        },
                        on: {
                          async xClick({ self }) {
                            const dialog = self.context();
                            const form = dialog.contentContainer.value;
                            const data = form.getData();
                            self.loading.value = true;
                            try {
                              await coreApiClient.call("retroactiveCharges", "create", undefined, data);
                              dialog.hide();
                              vueInstance.tableContainer.value.refresh();
                            } finally {
                              self.loading.value = false;
                            }
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const result = await coreApiClient.call("retroactiveCharges", "findAll", options);
              const { items, count } = result || {};
              return [items || [], count || 0];
            },
          },
        },
      },
    };
  },
});
